import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ResourceControlPolicySubscriptionVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type ResourceControlPolicySubscription = { __typename?: 'Subscription', resourceControlPolicy?: { __typename?: 'UpdateResourceControlPoliciesPayload', resourceControlPolicies?: { __typename?: 'ResourceControlPolicies', accessRequestsEnabled?: boolean | null, shareDefaultExpirySeconds?: number | null, shareDomainAccessEnabled: boolean, downloads?: { __typename?: 'DownloadsSettings', shareDownloadingEnabled?: boolean | null, adminCanEnableInShares?: boolean | null, fullAccessCanEnableInShares?: boolean | null, editAndShareCanEnableInShares?: boolean | null, adminInternal?: boolean | null, fullAccessInternal?: boolean | null, editAndShareInternal?: boolean | null } | null, drm?: { __typename?: 'DrmSettings', adminInternal?: boolean | null, adminCanDisableInShares?: boolean | null, commentOnlyInternal?: boolean | null, editAndShareInternal?: boolean | null, editAndShareCanDisableInShares?: boolean | null, editInternal?: boolean | null, fullAccessInternal?: boolean | null, fullAccessCanDisableInShares?: boolean | null, requiredForShares?: boolean | null, viewerInternal?: boolean | null } | null, forensicWatermark?: { __typename?: 'ForensicWatermarkSettings', adminInternal?: boolean | null, adminCanDisableInShares?: boolean | null, commentOnlyInternal?: boolean | null, editAndShareInternal?: boolean | null, editAndShareCanDisableInShares?: boolean | null, editInternal?: boolean | null, fallback?: Types.ForensicWatermarkFallback | null, fullAccessInternal?: boolean | null, fullAccessCanDisableInShares?: boolean | null, requiredForShares?: boolean | null, viewerInternal?: boolean | null } | null, shareAccess?: { __typename?: 'ShareAccessSettings', minimum?: Types.ShareAccess | null, default?: Types.ShareAccess | null, adminCanDisableInShares?: boolean | null, fullAccessCanDisableInShares?: boolean | null, editAndShareCanDisableInShares?: boolean | null } | null, sharePassphrase?: { __typename?: 'SharePassphraseSettings', required?: boolean | null, adminCanDisableInShares?: boolean | null, fullAccessCanDisableInShares?: boolean | null, editAndShareCanDisableInShares?: boolean | null } | null } | null } | null };


export const ResourceControlPolicy = /*#__PURE__*/ gql`
    subscription ResourceControlPolicy($accountId: ID!) {
  resourceControlPolicy(scope: {update: {accountId: $accountId}}) {
    ... on UpdateResourceControlPoliciesPayload {
      resourceControlPolicies {
        accessRequestsEnabled
        downloads {
          shareDownloadingEnabled
          adminCanEnableInShares
          fullAccessCanEnableInShares
          editAndShareCanEnableInShares
          adminInternal
          fullAccessInternal
          editAndShareInternal
        }
        drm {
          adminInternal
          adminCanDisableInShares
          commentOnlyInternal
          editAndShareInternal
          editAndShareCanDisableInShares
          editInternal
          fullAccessInternal
          fullAccessCanDisableInShares
          requiredForShares
          viewerInternal
        }
        forensicWatermark {
          adminInternal
          adminCanDisableInShares
          commentOnlyInternal
          editAndShareInternal
          editAndShareCanDisableInShares
          editInternal
          fallback
          fullAccessInternal
          fullAccessCanDisableInShares
          requiredForShares
          viewerInternal
        }
        shareAccess {
          minimum
          default
          adminCanDisableInShares
          fullAccessCanDisableInShares
          editAndShareCanDisableInShares
        }
        shareDefaultExpirySeconds
        shareDomainAccessEnabled
        sharePassphrase {
          required
          adminCanDisableInShares
          fullAccessCanDisableInShares
          editAndShareCanDisableInShares
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<ResourceControlPolicySubscription, ResourceControlPolicySubscriptionVariables>;

          

          export const useResourceControlPolicySubscription = (options?:SubscriptionHookOptions<ResourceControlPolicySubscription, ResourceControlPolicySubscriptionVariables>) => useSubscription(ResourceControlPolicy, options);

          

          export type ResourceControlPolicySubscriptionOptions = SubscriptionHookOptions<ResourceControlPolicySubscription, ResourceControlPolicySubscriptionVariables>;

          

          export type ResourceControlPolicySubscriptionResult = ReturnType<typeof useResourceControlPolicySubscription>;

          
